import { useState } from 'react';

export default function Compliance({ id }: { id?: string }) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const bullets = [
    {
      image: 'https://public.readdy.ai/ai/img_res/67445409365600b3362a284251941cd7.jpg',
      title: 'Sponsorships clearly labeled',
      text: 'All sponsor placements marked "Sponsored"'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=minimalist%20icon%20illustration%20of%20zero%20cost%20dollar%20sign%20crossed%20out%20simple%20clean%20design%20on%20white%20background%20flat%20style%20purple%20accent&width=120&height=120&seq=compliance-zero-cost&orientation=squarish',
      title: 'Facility pays $0',
      text: 'Does not receive sponsorship revenue'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=minimalist%20icon%20illustration%20of%20contract%20document%20handshake%20simple%20clean%20design%20on%20white%20background%20flat%20style%20purple%20accent&width=120&height=120&seq=compliance-contracts&orientation=squarish',
      title: 'Harmony Horizon contracts',
      text: 'We handle sponsor sales and billing'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=minimalist%20icon%20illustration%20of%20shield%20with%20checkmark%20data%20protection%20simple%20clean%20design%20on%20white%20background%20flat%20style%20purple%20accent&width=120&height=120&seq=compliance-no-phi&orientation=squarish',
      title: 'No PHI collected',
      text: 'No resident lists or health data needed'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=minimalist%20icon%20illustration%20of%20document%20with%20checkmark%20approval%20review%20simple%20clean%20design%20on%20white%20background%20flat%20style%20purple%20accent&width=120&height=120&seq=compliance-review&orientation=squarish',
      title: 'Facility reviews final proof',
      text: 'Brand alignment before distribution'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=minimalist%20icon%20illustration%20of%20heart%20with%20pulse%20line%20general%20wellness%20simple%20clean%20design%20on%20white%20background%20flat%20style%20purple%20accent&width=120&height=120&seq=compliance-not-medical&orientation=squarish',
      title: 'Not medical advice',
      text: 'General-interest content only'
    }
  ];

  return (
    <section id={id} className="py-8 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-5">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Monetization &amp; Compliance
          </h2>
          <p className="text-sm text-gray-600">
            Clear guidelines. Peace of mind.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
          {bullets.map((item, index) => (
            <div
              key={index}
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
              className={`bg-white rounded-xl p-4 border cursor-pointer transition-all duration-300 ${
                activeIndex === index
                  ? 'border-purple-300 shadow-lg scale-105 bg-gradient-to-br from-purple-50/50 to-orange-50/30'
                  : 'border-gray-200 shadow-sm hover:border-purple-200'
              }`}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 mb-3 rounded-lg overflow-hidden bg-white shadow-sm">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-gray-500 text-center">
          Harmony Horizon is a media partner, not a healthcare provider. We contract with sponsors and handle all billing. Facilities do not control sponsors or receive revenue.
        </p>
      </div>
    </section>
  );
}
